import { router, usePage } from "@inertiajs/react"
import { Briefcase, Check, ChevronDown } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { frontAccountSelections } from "@/routes"

/**
 * The current account next to the logo, with a menu to switch. Shown to people who belong to
 * several. An account the person is the accountant of opens the accounting app.
 */
export function AccountSwitcher() {
  const accounts = usePage().props.account_context
  if (!accounts) return null

  const { current, all } = accounts

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`Account: ${current.name}. Switch account`}
        className="inline-flex max-w-40 items-center gap-1.5 rounded-md px-2 py-2 text-sm font-semibold text-inverse-foreground outline-none hover:bg-inverse-hover focus-visible:ring-2 focus-visible:ring-inverse-foreground sm:max-w-56"
      >
        <Briefcase className="size-4 shrink-0 text-inverse-muted-foreground" aria-hidden="true" />
        <span className="truncate">{current.name}</span>
        <ChevronDown className="size-4 shrink-0 text-inverse-muted-foreground" aria-hidden="true" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel>Switch account</DropdownMenuLabel>
        {all.map((account) => (
          <DropdownMenuItem
            key={account.id}
            disabled={account.id === current.id}
            onSelect={() => router.post(frontAccountSelections.create().url, { account_id: account.id })}
          >
            <span className="min-w-0 flex-1">
              <span className="block truncate">{account.name}</span>
              {account.accounting && <span className="block text-xs text-muted-foreground">As accountant</span>}
            </span>
            {account.id === current.id && <Check className="size-4" aria-label="Current account" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
